//#region components/description_list/description_list_validators.js
var e = (e) => e.term ? typeof e.term == "string" : !1, t = (e) => e.description ? typeof e.description == "string" : !1, n = (n) => Array.isArray(n) ? n.every((n) => !(typeof n != "object" || !e(n) || !t(n))) : !1;
//#endregion
export { n as itemsValidator };

//# sourceMappingURL=description-list-validators.js.map